import React, { FC, memo } from 'react';
import testIds from '@smart-tv/e2e/shared/variables';
import Image from '@smart-tv/components/image';
import Typography from '@smart-tv/components/typography';
import useFavoritesEdit from '@smart-tv/hooks/use-favorites-edit';
import styles from '../favorites.module.scss';
import { useFavoritesLists } from '@smart-tv/hooks/use-favorites-lists/use-favorites-lists';

export const FavoritesHomeChannels: FC = () => {
  const { channels, listID, usedFavoritesLists } = useFavoritesEdit();
  const { selectedFavoritesList } = useFavoritesLists();
  const focusedFavoritesList = usedFavoritesLists?.find((list) => list.id === listID);
  const visibleFavoritesList = focusedFavoritesList || selectedFavoritesList;

  if (channels && visibleFavoritesList && visibleFavoritesList.sids.length != 0) {
    return (
      <div
        className={styles['favorites-home-channels-layout']}
        data-testid={testIds.favorites.home.channels}
      >
        {visibleFavoritesList.sids
          .map((sid) => channels.find((channel) => channel.sid === sid))
          .map((channel) =>
            channel ? (
              <Image
                className={styles['favorites-home-channels-root--image']}
                key={channel.sid}
                src={channel.icon}
              />
            ) : (
              ''
            )
          )}
      </div>
    );
  }

  return (
    <div
      className={styles['favorites-home-channels-layout']}
      data-testid={testIds.favorites.home.channels}
    >
      {channels?.map((channel) => (
        <Image
          className={styles['favorites-home-channels-root--image']}
          key={channel.sid}
          src={channel.icon}
        />
      ))}
      <Typography
        className={styles['favorites-home-channels-root--desc']}
        data-testid={testIds.favorites.home.channelsDescription1}
      >
        Du kan ikke redigere denne kanalliste.
      </Typography>
      <Typography fontWeight="bold" data-testid={testIds.favorites.home.channelsDescription2}>
        Opret en ny eller redigér en af dine eksisterende lister.
      </Typography>
    </div>
  );
};

export default memo(FavoritesHomeChannels);
